<template>
    <img
        v-if="loadLazy"
        v-lazy="imageUrl"
        :style="imageStyle"
        :width="intrinsicWidth ? intrinsicWidth : width"
        :height="intrinsicHeight ? intrinsicHeight : height"
        :alt="alt"
    />
    <img
        v-else
        :src="imageUrl"
        :style="imageStyle"
        :width="intrinsicWidth ? intrinsicWidth : width"
        :height="intrinsicHeight ? intrinsicHeight : height"
        :alt="alt"
    />
</template>

<script>
import { helper } from '@/mixins';
export default {
    name: 'BaseImage',
    mixins: [helper],
    props: {
        imgSource: {
            type: String,
        },
        loadLazy: {
            type: Boolean,
            default: false,
        },
        width: {
            type: String,
        },
        height: {
            type: String,
        },
        quality: {
            type: [String, Number],
        },
        intrinsicHeight: {
            type: String,
            default: null,
        },
        intrinsicWidth: {
            type: String,
            default: null,
        },
        renderWidth: {
            type: String,
            default: null,
        },
        renderHeight: {
            type: String,
            default: null,
        },
        isHighResolution: {
            type: Boolean,
            default: false,
        },
        alt: {
            type: String,
            default: 'image',
        },
        color: {
            type: String,
        },
        fetchpriority: {
            type: String,
            default: '',
        },
    },
    methods: {
        increaseSize(size) {
            return this.isHighResolution
                ? parseInt(size) * 1.2
                : parseInt(size);
        },
        resizeImage(imgString, width, height, quality = 60, color = '') {
            const imageUrl = this.$globalConstants.imageUrl;

            // skip resize params for gif images
            if (imgString && imgString.toLowerCase().includes('.gif')) {
                return `${imageUrl}/${imgString}`;
            }

            const dimString =
                width && height
                    ? '&d=' +
                      this.increaseSize(width) +
                      'x' +
                      this.increaseSize(height)
                    : '';
            if (color) {
                return `${imageUrl}/${imgString}?q=${quality}${dimString}&color=${color.replace(
                    '#',
                    ''
                )}`;
            }
            return `${imageUrl}/${imgString}?q=${quality}${dimString}`;
        },
    },
    computed: {
        imageStyle() {
            const width = this.renderWidth ? this.renderWidth : this.width;
            const height = this.renderHeight ? this.renderHeight : this.height;
            return width && height ? { width, height } : {};
        },
        imageUrl() {
            if (
                typeof this.imgSource === 'string' &&
                this.imgSource.includes('https://')
            ) {
                return (
                    this.imgSource +
                    `?d=${this.width}x${this.height}&q=${this.quality}`
                );
            }

            return this.resizeImage(
                this.imgSource,
                this.width,
                this.height,
                this.quality,
                this.color ? this.color : ''
            );
        },
    },
};
</script>
